import React, { Component } from "react";
import { register, checkRegisterDisponibilidade } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import { Formik } from 'formik';
import { connect } from "react-redux";
import { validateConfirmacao, validateCriacaoSenha } from "../../utils/formValidators";
import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import { Col, Container, Row } from "react-bootstrap";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import Swal from "sweetalert2";
import { FaBuilding, FaTruck, FaWarehouse, FaLock } from 'react-icons/fa';
import { buscaCep, formatCepInput, formatCNPJ, formatCNPJInput, formatCPFInput, formatTelefoneInput } from "../../utils/Utils";
import { Document, Page } from 'react-pdf';
import BetterSelect from '../../components/BetterSelect';
import OnboardingStepper, { ONBOARDING_STEPS } from '../../components/OnboardingStepper';
import { handleApiError } from "../../utils/ErrorHandler";
import { TIPOS_RNTRC } from "../../utils/tiposRntrc";
import { CARGOS_COLABORADORES, isCargoColaboradorValido } from "../../utils/cargosColaboradores";
import "./Register.module.scss";
import CadastroConclusao from "../../components/cadastro/CadastroConclusao";
import EmpresaCnaeNaturezaFields, {
	EMPRESA_CNAE_NATUREZA_INITIAL,
	EMPRESA_CNAE_NATUREZA_STRIP_KEYS,
} from "../../components/minhaEmpresa/EmpresaCnaeNaturezaFields";

class Register extends Component {
	constructor() {
		super();

		this.state = {
			loading: false,
			step: 'tipoConta',
			tokenType: '',
			checked: false,
			termosLidos: false,
			emp_logo: null,
			stepsNumber: 0,
			numPages: null,
			pageNumber: 1,
			identificacao: {
				emp_cnpj: '',
				emp_rntrc: '',
				rntrc_tipo: 'ETC',
				vinculo: 'ResponsavelLegal',
				usu_cpf: '',
				usu_cpf_funcionario: '',
				usu_cargo: '',
				canal: 'Celular',
				usu_celular: '',
				email: '',
			},
			codigoVerificacao: ['', '', '', '', '', ''],
			cadastroDraft: null,
			termosDocWidth: 480,
			checkingDisponibilidade: false,
		};
	}

	componentDidMount() {
		this._onResizeTermos = () => {
			if (this.state.step === 'termos') this.measureTermosDoc();
		};
		window.addEventListener('resize', this._onResizeTermos);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._onResizeTermos);
	}

	componentDidUpdate(_, prevState) {
		if (this.state.step === 'termos' && prevState.step !== 'termos') {
			window.setTimeout(() => this.measureTermosDoc(), 50);
		}
	}

	measureTermosDoc = () => {
		const box = document.querySelector('.register-termos__doc');
		if (!box) return;
		const width = Math.max(280, Math.floor(box.clientWidth - 8));
		if (width !== this.state.termosDocWidth) {
			this.setState({ termosDocWidth: width });
		}
	}

	mostrarErrosDisponibilidade = (error) => {
		const data = error?.response?.data;
		const errors = data?.errors;
		if (errors && typeof errors === 'object') {
			const list = Object.values(errors).flat().filter(Boolean);
			if (list.length) {
				return Swal.fire({
					title: 'Ops!',
					html: `<ul style="text-align:left;list-style-position:inside;padding-left:0;">${list.map((e) => `<li>${e}</li>`).join('')}</ul>`,
					icon: 'warning',
				});
			}
		}
		return handleApiError(error);
	}

	checarDisponibilidade = async (payload) => {
		this.setState({ checkingDisponibilidade: true });
		try {
			await checkRegisterDisponibilidade(payload);
			return true;
		} catch (error) {
			this.mostrarErrosDisponibilidade(error);
			return false;
		} finally {
			this.setState({ checkingDisponibilidade: false });
		}
	}

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages, pageNumber: 1 }, () => {
			this.measureTermosDoc();
			window.setTimeout(() => this.checkTermosScrollComplete(), 300);
		});
	}

	onTermosScroll = (e) => {
		const el = e.target;
		if (!el) return;
		this.checkTermosScrollComplete(el);
	}

	checkTermosScrollComplete = (el) => {
		const box = el || document.querySelector('.register-termos__doc');
		if (!box) return;
		const semScroll = box.scrollHeight <= box.clientHeight + 8;
		const noFim = box.scrollTop + box.clientHeight >= box.scrollHeight - 24;
		if ((semScroll || noFim) && !this.state.termosLidos) {
			this.setState({ termosLidos: true });
		}
	}



	onSubmit = (values) => {
		this.setState({ loading: true });

		var formData = new FormData();
		const id = this.state.identificacao || {};

		const payload = {
			...values,
			usu_cep: values.usu_cep || values.emp_cep || '',
			usu_rua: values.usu_rua || values.emp_logradouro || '',
			usu_numero: values.usu_numero || values.emp_logradouro_numero || '',
			usu_bairro: values.usu_bairro || values.emp_bairro || '',
			usu_cidade: values.usu_cidade || values.emp_municipio || '',
			usu_uf: values.usu_uf || values.emp_estado || '',
			usu_complemento: values.usu_complemento || values.emp_endereco_complemento || '',
			usu_celular: values.usu_celular || id.usu_celular || values.emp_telefone || '',
			vinculo: values.vinculo || id.vinculo || 'ResponsavelLegal',
			usu_cargo: values.usu_cargo || id.usu_cargo || '',
			emp_cnpj: values.emp_cnpj || id.emp_cnpj || '',
			emp_rntrc: values.emp_rntrc || id.emp_rntrc || '',
			rntrc_tipo: values.rntrc_tipo || id.rntrc_tipo || 'ETC',
			emp_faturamento: values.emp_faturamento || '0',
			emp_num_filiais: values.emp_num_filiais || '0',
			emp_quantidade_veiculos_proprios: values.emp_quantidade_veiculos_proprios || '0',
			emp_quantidade_veiculos_agregados: values.emp_quantidade_veiculos_agregados || '0',
			emp_data_inicio_atividades: values.emp_data_inicio_atividades || new Date().toISOString().slice(0, 10),
		};

		const isFuncionario = payload.vinculo === 'Funcionario';
		if (isFuncionario) {
			payload.usu_cpf = values.usu_cpf || id.usu_cpf_funcionario || '';
			payload.rl_cpf = values.rl_cpf || id.usu_cpf || '';
			payload.rl_cargo = values.rl_cargo || '';
			payload.rl_nome = values.rl_nome || '';
			payload.rl_email = values.rl_email || '';
			payload.rl_celular = values.rl_celular || '';
		} else {
			payload.usu_cpf = values.usu_cpf || id.usu_cpf || '';
		}

		Object.keys(payload).forEach((key) => {
			if (
				key === 'confirm' ||
				key === 'emp_logo' ||
				key === 'emp_email' ||
				key === 'emp_tipo_endereco' ||
				EMPRESA_CNAE_NATUREZA_STRIP_KEYS.includes(key)
			) {
				return;
			}
			const val = payload[key];
			if (val !== null && val !== undefined && val !== '') {
				formData.append(key, val);
			}
		});

		formData.append('empresa_termo', this.state.checked ? 1 : 0);
		const tipoEmpresa =
			this.state.tokenType === 'Transportadora'
				? 'Transportadora'
				: this.state.tokenType === 'Armazem'
					? 'Armazém'
					: 'Embarcadora';
		formData.append('emp_tipo_empresa', tipoEmpresa);

		register(formData).then(({ data }) => {
			if (data.errors) {
				this.setState({ loading: false });
				return Swal.fire('Ops!', Array.isArray(data.errors) ? data.errors[0] : data.errors, 'error');
			}

			this.setState({ loading: false, step: 'bemVindo', stepsNumber: 1 });
		}).catch((error) => {
			handleApiError(error);
			this.setState({ loading: false });
		});
	}

	getInitialValues = () => {
		const id = this.state.identificacao || {};
		const draft = this.state.cadastroDraft || {};
		const isFuncionario = (draft.vinculo || id.vinculo) === 'Funcionario';
		return {
			emp_razao_social: draft.emp_razao_social || '',
			emp_nome_fantasia: draft.emp_nome_fantasia || '',
			emp_cnpj: draft.emp_cnpj || id.emp_cnpj || '',
			emp_inscricao_estadual: draft.emp_inscricao_estadual || '',
			emp_inscricao_municipal: draft.emp_inscricao_municipal || '',
			emp_tipo_endereco: draft.emp_tipo_endereco || '',
			...EMPRESA_CNAE_NATUREZA_INITIAL,
			emp_situacao_cadastral: draft.emp_situacao_cadastral || '',
			emp_natureza_juridica_codigo: draft.emp_natureza_juridica_codigo || '',
			emp_natureza_juridica_descricao: draft.emp_natureza_juridica_descricao || '',
			emp_tipo_societario: draft.emp_tipo_societario || '',
			emp_cnae_principal_codigo: draft.emp_cnae_principal_codigo || '',
			emp_cnae_principal_descricao: draft.emp_cnae_principal_descricao || '',
			emp_cnaes_secundarios: draft.emp_cnaes_secundarios || '',
			emp_cep: draft.emp_cep || '',
			emp_logradouro: draft.emp_logradouro || '',
			emp_logradouro_numero: draft.emp_logradouro_numero || '',
			emp_endereco_complemento: draft.emp_endereco_complemento || '',
			emp_bairro: draft.emp_bairro || '',
			emp_municipio: draft.emp_municipio || '',
			emp_estado: draft.emp_estado || '',
			emp_email: draft.emp_email || '',
			emp_telefone: draft.emp_telefone || '',
			password: '',
			confirm: '',
			vinculo: draft.vinculo || id.vinculo || 'ResponsavelLegal',
			usu_cargo: draft.usu_cargo || id.usu_cargo || '',
			usu_cpf: isFuncionario
				? (draft.usu_cpf || id.usu_cpf_funcionario || '')
				: (draft.usu_cpf || id.usu_cpf || ''),
			usu_nome: draft.usu_nome || '',
			usu_celular: isFuncionario
				? (draft.usu_celular || id.usu_celular || '')
				: (draft.usu_celular || id.usu_celular || ''),
			email: draft.email || (!isFuncionario ? (id.email || '') : ''),
			rl_cpf: isFuncionario ? (draft.rl_cpf || id.usu_cpf || '') : '',
			rl_cargo: draft.rl_cargo || '',
			rl_nome: draft.rl_nome || '',
			rl_celular: draft.rl_celular || '',
			rl_email: draft.rl_email || '',
			usu_cep: draft.usu_cep || '',
			usu_bairro: draft.usu_bairro || '',
			usu_rua: draft.usu_rua || '',
			usu_numero: draft.usu_numero || '',
			usu_cidade: draft.usu_cidade || '',
			usu_uf: draft.usu_uf || '',
			usu_complemento: draft.usu_complemento || '',
			emp_logo: draft.emp_logo || '',
			emp_flag_matriz_filial: draft.emp_flag_matriz_filial || 'Matriz',
			emp_faturamento: draft.emp_faturamento || '',
			emp_data_inicio_atividades: draft.emp_data_inicio_atividades || '',
			emp_num_filiais: draft.emp_num_filiais || '',
			emp_quantidade_veiculos_proprios: draft.emp_quantidade_veiculos_proprios || '',
			emp_quantidade_veiculos_agregados: draft.emp_quantidade_veiculos_agregados || '',
			emp_rntrc: draft.emp_rntrc || id.emp_rntrc || '',
			rntrc_tipo: draft.rntrc_tipo || id.rntrc_tipo || 'ETC',
		};
	}

	removerFoto = (setFieldValue) => {
		setFieldValue('emp_logo', null);

		this.setState({ emp_logo: null });
	};

	switchEtapas = () => {
		switch (this.state.step) {
			case 'tipoConta':
				return this.tipoConta();

			case 'identificacao':
				return this.identificacao();

			case 'verificacao':
				return this.verificacao();

			case 'termos':
				return this.termos();

			case 'cadastroForm':
				return this.cadastroForm();

			case 'criacaoSenha':
				return this.criacaoSenha();

			case 'bemVindo':
				return this.bemVindo();
			default:
				return;
		}
	}

	perfilLabel = () => {
		const map = {
			Empresa: 'Embarcador',
			Transportadora: 'Transportador',
			Armazem: 'Armazém',
		};
		return map[this.state.tokenType] || this.state.tokenType;
	}

	tipoConta = () => (
		<div>
			<div className="d-flex arrowLeft align-items-baseline">
				<AiOutlineArrowLeft className="pointer mr-3" size={20} color="#122150" onClick={() => this.props.history.goBack()} />

				<h1>Como deseja operar?</h1>
			</div>

			<p className="selectProfile">Selecione seu perfil para começar</p>

			<div className="boxContainer">
				<div className="box" onClick={() => this.setState({ step: 'identificacao', tokenType: 'Empresa' })}>
					<div className="imageContainer">
						<FaBuilding size={22} color="#122150" />
					</div>

					<div className="phraseContainer">
						<h3>Embarcador</h3>

						<p className="m-0">Empresa responsável pela contratação do transporte</p>
					</div>

					<div className="boxArrow">
						<AiOutlineArrowRight size={20} color="#D92D20" />
					</div>
				</div>

				<div className="box" onClick={() => this.setState({ step: 'identificacao', tokenType: 'Transportadora' })}>
					<div className="imageContainer">
						<FaTruck size={22} color="#122150" />
					</div>

					<div className="phraseContainer">
						<h3>Transportador</h3>

						<p className="m-0">Empresa ou cooperativa de transporte de cargas</p>
					</div>

					<div className="boxArrow">
						<AiOutlineArrowRight size={20} color="#ff3d1c" />
					</div>
				</div>

				<div className="box" onClick={() => this.setState({ step: 'identificacao', tokenType: 'Armazem' })}>
					<div className="imageContainer">
						<FaWarehouse size={22} color="#122150" />
					</div>

					<div className="phraseContainer">
						<h3>Armazém</h3>

						<p className="m-0">Unidade responsável pelo carregamento ou descarregamento</p>
					</div>

					<div className="boxArrow">
						<AiOutlineArrowRight size={20} color="#ff3d1c" />
					</div>
				</div>
			</div>
		</div>
	)

	identificacao = () => {
		const initial = this.state.identificacao;
		const isTransp = this.state.tokenType === 'Transportadora';
		const cargos = CARGOS_COLABORADORES;

		const toggleBtn = (ativo) => ({
			flex: 1,
			minHeight: 48,
			borderRadius: 8,
			border: ativo ? '2px solid #F6A900' : '1px solid #CED4DA',
			backgroundColor: '#fff',
			color: ativo ? '#F6A900' : '#122150',
			fontWeight: 600,
			fontSize: 14,
			fontFamily: 'Roboto, Arial, sans-serif',
			cursor: 'pointer',
			padding: '10px 12px',
		});

		const section = {
			background: '#F7F8FA',
			borderRadius: 12,
			padding: '16px 16px 8px',
			marginBottom: 16,
		};

		const sectionTitle = {
			color: '#122150',
			fontWeight: 600,
			fontSize: 14,
			marginBottom: 12,
		};

		const fieldLabel = {
			display: 'block',
			fontSize: 13,
			fontWeight: 600,
			color: '#122150',
			marginBottom: 6,
		};

		return (
			<div className="register-id">
				<div className="d-flex arrowLeft align-items-baseline">
					<AiOutlineArrowLeft className="pointer mr-3" size={20} color="#122150" onClick={() => this.setState({ step: 'tipoConta' })} />
					<h1>Identificação</h1>
				</div>
				<p style={{ color: '#596165', fontSize: 14, marginBottom: 4 }}>Informe seu CNPJ para continuar</p>
				<p className="tokenTypeAsset mb-4">{this.perfilLabel()}</p>

				<Formik
					key="identificacao"
					initialValues={initial}
					validate={(values) => {
						const errors = {};
						if (!values.emp_cnpj || values.emp_cnpj.replace(/\D/g, '').length !== 14) errors.emp_cnpj = 'Informe um CNPJ válido para continuar.';
						if (isTransp && !values.emp_rntrc) errors.emp_rntrc = 'Informe o RNTRC para continuar.';
						if (isTransp && !values.rntrc_tipo) errors.rntrc_tipo = 'Selecione o tipo de RNTRC.';
						if (!values.vinculo) errors.vinculo = 'Selecione o vínculo com a empresa.';
						if (values.vinculo === 'Funcionario') {
							if (!values.usu_cpf_funcionario || values.usu_cpf_funcionario.replace(/\D/g, '').length !== 11) errors.usu_cpf_funcionario = 'Informe um CPF válido para continuar.';
							if (!values.usu_cargo) {
								errors.usu_cargo = 'Selecione o cargo do funcionário para continuar.';
							} else if (!isCargoColaboradorValido(values.usu_cargo)) {
								errors.usu_cargo = 'Selecione um cargo válido para o funcionário.';
							}
						}
						if (!values.usu_cpf || values.usu_cpf.replace(/\D/g, '').length !== 11) errors.usu_cpf = 'Informe um CPF válido para continuar.';
						if (!values.canal) errors.canal = 'Selecione o canal de recebimento.';
						if (values.canal === 'Celular') {
							if (!values.usu_celular || values.usu_celular.replace(/\D/g, '').length < 10) errors.usu_celular = 'Informe um celular válido.';
						} else if (!values.email) {
							errors.email = 'Informe um endereço de E-mail válido.';
						}
						return errors;
					}}
					onSubmit={async (values) => {
						const livre = await this.checarDisponibilidade({
							emp_cnpj: values.emp_cnpj,
							vinculo: values.vinculo,
							usu_cpf: values.vinculo === 'Funcionario' ? values.usu_cpf_funcionario : values.usu_cpf,
							...(values.vinculo === 'Funcionario' ? { rl_cpf: values.usu_cpf } : {}),
							...(values.canal === 'Email' && values.email ? { email: values.email } : {}),
						});
						if (!livre) return;
						this.setState({
							identificacao: values,
							step: 'verificacao',
							codigoVerificacao: ['', '', '', '', '', ''],
						});
					}}
				>
					{({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
						const cnpjOk = (values.emp_cnpj || '').replace(/\D/g, '').length === 14;
						const rntrcOk = !isTransp || (Boolean(values.emp_rntrc) && Boolean(values.rntrc_tipo));
						const cpfRlOk = (values.usu_cpf || '').replace(/\D/g, '').length === 11;
						const funcOk = values.vinculo !== 'Funcionario'
							|| (((values.usu_cpf_funcionario || '').replace(/\D/g, '').length === 11) && values.usu_cargo);
						const canalOk = values.canal === 'Celular'
							? (values.usu_celular || '').replace(/\D/g, '').length >= 10
							: Boolean(values.email);
						const podeEnviar = cnpjOk && rntrcOk && cpfRlOk && funcOk && canalOk;

						return (
							<form noValidate autoComplete="off" onSubmit={handleSubmit}>
								<div style={section}>
									<p style={sectionTitle}>Dados da empresa</p>
									<Row>
										<Col xs={12} className="px-2 pb-3">
											<label style={fieldLabel} htmlFor="emp_cnpj">CNPJ *</label>
											<FormControl fullWidth error={Boolean(touched.emp_cnpj && errors.emp_cnpj)}>
												<TextField
													id="emp_cnpj"
													type="text"
													variant="outlined"
													name="emp_cnpj"
													placeholder="00.000.000/0000-00"
													inputProps={{ maxLength: 18 }}
													onBlur={handleBlur}
													error={Boolean(touched.emp_cnpj && errors.emp_cnpj)}
													onChange={e => handleChange(formatCNPJInput(e))}
													value={values.emp_cnpj}
												/>
												{touched.emp_cnpj && errors.emp_cnpj && <FormHelperText>{errors.emp_cnpj}</FormHelperText>}
											</FormControl>
										</Col>
										{isTransp ? (
										<>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel} htmlFor="emp_rntrc">RNTRC (ANTT) *</label>
											<FormControl fullWidth error={Boolean(touched.emp_rntrc && errors.emp_rntrc)}>
												<TextField
													id="emp_rntrc"
													type="text"
													variant="outlined"
													name="emp_rntrc"
													placeholder="Informe o RNTRC"
													onBlur={handleBlur}
													error={Boolean(touched.emp_rntrc && errors.emp_rntrc)}
													onChange={handleChange}
													value={values.emp_rntrc}
													inputProps={{ translate: 'no' }}
												/>
												{touched.emp_rntrc && errors.emp_rntrc && (
													<FormHelperText>{errors.emp_rntrc}</FormHelperText>
												)}
											</FormControl>
										</Col>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel} htmlFor="rntrc_tipo">Tipo de RNTRC *</label>
											<FormControl fullWidth error={Boolean(touched.rntrc_tipo && errors.rntrc_tipo)}>
												<TextField
													id="rntrc_tipo"
													select
													variant="outlined"
													name="rntrc_tipo"
													value={values.rntrc_tipo || 'ETC'}
													onBlur={handleBlur}
													onChange={handleChange}
													error={Boolean(touched.rntrc_tipo && errors.rntrc_tipo)}
													SelectProps={{ native: true }}
													inputProps={{ translate: 'no' }}
												>
													{TIPOS_RNTRC.map((opt) => (
														<option key={opt.value} value={opt.value}>
															{opt.value}
														</option>
													))}
												</TextField>
												{touched.rntrc_tipo && errors.rntrc_tipo && (
													<FormHelperText>{errors.rntrc_tipo}</FormHelperText>
												)}
											</FormControl>
										</Col>
										<Col xs={12} className="px-2" style={{ marginTop: -8, marginBottom: 12 }}>
											<span style={{ display: 'block', fontSize: 12, color: '#596165', lineHeight: 1.4 }}>
												Número de Registro Nacional de Transportadores Rodoviários de Cargas
											</span>
										</Col>
										</>
										) : null}
									</Row>
								</div>

								<div style={section}>
									<p style={sectionTitle}>Qual é o seu vínculo com a empresa? *</p>
									<div className="d-flex px-1 pb-3" style={{ gap: 12 }}>
										<button type="button" style={toggleBtn(values.vinculo === 'Funcionario')} onClick={() => setFieldValue('vinculo', 'Funcionario')}>
											Funcionário
										</button>
										<button type="button" style={toggleBtn(values.vinculo === 'ResponsavelLegal')} onClick={() => setFieldValue('vinculo', 'ResponsavelLegal')}>
											Responsável Legal
										</button>
									</div>

									{values.vinculo === 'Funcionario' && (
										<Row>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel} htmlFor="usu_cpf_funcionario">CPF do Funcionário *</label>
												<FormControl fullWidth error={Boolean(touched.usu_cpf_funcionario && errors.usu_cpf_funcionario)}>
													<TextField
														id="usu_cpf_funcionario"
														type="text"
														variant="outlined"
														name="usu_cpf_funcionario"
														placeholder="000.000.000-00"
														inputProps={{ maxLength: 14 }}
														onBlur={handleBlur}
														error={Boolean(touched.usu_cpf_funcionario && errors.usu_cpf_funcionario)}
														onChange={e => handleChange(formatCPFInput(e))}
														value={values.usu_cpf_funcionario}
													/>
													{touched.usu_cpf_funcionario && errors.usu_cpf_funcionario && <FormHelperText>{errors.usu_cpf_funcionario}</FormHelperText>}
												</FormControl>
											</Col>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel} htmlFor="usu_cargo">Cargo do Funcionário *</label>
												<FormControl fullWidth error={Boolean(touched.usu_cargo && errors.usu_cargo)}>
													<TextField
														id="usu_cargo"
														select
														SelectProps={{ native: true }}
														variant="outlined"
														name="usu_cargo"
														value={values.usu_cargo}
														onChange={handleChange}
														onBlur={handleBlur}
														error={Boolean(touched.usu_cargo && errors.usu_cargo)}
														fullWidth
													>
														<option value="">Selecione</option>
														{cargos.map((c) => <option key={c} value={c}>{c}</option>)}
													</TextField>
													{touched.usu_cargo && errors.usu_cargo && <FormHelperText>{errors.usu_cargo}</FormHelperText>}
												</FormControl>
											</Col>
										</Row>
									)}

									<Row>
										<Col xs={12} className="px-2 pb-3">
											<label style={fieldLabel} htmlFor="usu_cpf">CPF do Responsável Legal *</label>
											<FormControl fullWidth error={Boolean(touched.usu_cpf && errors.usu_cpf)}>
												<TextField
													id="usu_cpf"
													type="text"
													variant="outlined"
													name="usu_cpf"
													placeholder="000.000.000-00"
													inputProps={{ maxLength: 14 }}
													onBlur={handleBlur}
													error={Boolean(touched.usu_cpf && errors.usu_cpf)}
													onChange={e => handleChange(formatCPFInput(e))}
													value={values.usu_cpf}
												/>
												{touched.usu_cpf && errors.usu_cpf && <FormHelperText>{errors.usu_cpf}</FormHelperText>}
											</FormControl>
										</Col>
									</Row>
								</div>

								<div style={section}>
									<p style={sectionTitle}>Como deseja receber o código de verificação?</p>
									<div className="d-flex px-1 pb-3" style={{ gap: 12 }}>
										<button type="button" style={toggleBtn(values.canal === 'Celular')} onClick={() => setFieldValue('canal', 'Celular')}>
											Celular
										</button>
										<button type="button" style={toggleBtn(values.canal === 'Email')} onClick={() => setFieldValue('canal', 'Email')}>
											E-mail
										</button>
									</div>

									<Row>
										<Col xs={12} className="px-2 pb-3">
											{values.canal === 'Celular' ? (
												<>
													<label style={fieldLabel} htmlFor="usu_celular">Celular *</label>
													<FormControl fullWidth error={Boolean(touched.usu_celular && errors.usu_celular)}>
														<TextField
															id="usu_celular"
															type="text"
															variant="outlined"
															name="usu_celular"
															placeholder="(00) 00000-0000"
															inputProps={{ maxLength: 15 }}
															onBlur={handleBlur}
															error={Boolean(touched.usu_celular && errors.usu_celular)}
															onChange={e => handleChange(formatTelefoneInput(e))}
															value={values.usu_celular}
														/>
														{touched.usu_celular && errors.usu_celular && <FormHelperText>{errors.usu_celular}</FormHelperText>}
													</FormControl>
												</>
											) : (
												<>
													<label style={fieldLabel} htmlFor="email">E-mail *</label>
													<FormControl fullWidth error={Boolean(touched.email && errors.email)}>
														<TextField
															id="email"
															type="email"
															variant="outlined"
															name="email"
															placeholder="seu@email.com"
															onBlur={handleBlur}
															error={Boolean(touched.email && errors.email)}
															onChange={handleChange}
															value={values.email}
														/>
														{touched.email && errors.email && <FormHelperText>{errors.email}</FormHelperText>}
													</FormControl>
												</>
											)}
										</Col>
									</Row>
								</div>

								<div className="px-1 pt-2 pb-4">
									<button
										type="button"
										className={`register-enviar${podeEnviar && !this.state.checkingDisponibilidade ? '' : ' is-disabled'}`}
										onClick={() => handleSubmit()}
										disabled={!podeEnviar || this.state.checkingDisponibilidade}
										aria-label="Enviar"
									>
										<svg width="72" height="22" viewBox="0 0 72 22" aria-hidden="true" focusable="false">
											<text x="36" y="16" textAnchor="middle" fill="#122150" fontFamily="Arial, Helvetica, sans-serif" fontSize="16" fontWeight="700">{this.state.checkingDisponibilidade ? '...' : 'Enviar'}</text>
										</svg>
									</button>
								</div>
							</form>
						);
					}}
				</Formik>
			</div>
		);
	}

	verificacao = () => {
		const id = this.state.identificacao || {};
		const codigo = this.state.codigoVerificacao || ['', '', '', '', '', ''];
		const completo = codigo.every((d) => d !== '');
		const canal = id.canal === 'Email' ? 'E-mail' : 'WhatsApp';
		const destino = id.canal === 'Email'
			? (id.email || '')
			: (id.usu_celular || '');

		const setDigito = (index, raw) => {
			const digit = String(raw || '').replace(/\D/g, '').slice(-1);
			const next = [...codigo];
			next[index] = digit;
			this.setState({ codigoVerificacao: next }, () => {
				if (digit && index < 5) {
					const el = document.getElementById(`otp-${index + 1}`);
					if (el) el.focus();
				}
			});
		};

		const onKeyDown = (index, e) => {
			if (e.key === 'Backspace' && !codigo[index] && index > 0) {
				const el = document.getElementById(`otp-${index - 1}`);
				if (el) el.focus();
			}
		};

		const confirmar = () => {
			if (!completo) return;
			this.setState({ step: 'termos', stepsNumber: 0, termosLidos: false, pageNumber: 1, checked: false });
		};

		return (
			<div>
				<div className="d-flex arrowLeft align-items-baseline">
					<AiOutlineArrowLeft
						className="pointer mr-3"
						size={20}
						color="#122150"
						onClick={() => this.setState({ step: 'identificacao' })}
					/>
					<h1>Verificação</h1>
				</div>
				<p style={{ color: '#596165', fontSize: 14, marginBottom: 8 }}>
					Enviamos um código para o seu {canal}{destino ? ` (${destino})` : ''}.
				</p>
				{id.canal !== 'Email' && (
					<p style={{ color: '#596165', fontSize: 13, marginBottom: 16 }}>
						Confira seu WhatsApp para verificar se o código foi recebido.
					</p>
				)}
				<p className="tokenTypeAsset mb-3">{this.perfilLabel()}</p>

				<p style={{ fontWeight: 600, marginBottom: 12 }}>Código de verificação</p>
				<div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 24 }}>
					{codigo.map((digito, index) => (
						<input
							key={index}
							id={`otp-${index}`}
							type="text"
							inputMode="numeric"
							maxLength={1}
							value={digito}
							onChange={(e) => setDigito(index, e.target.value)}
							onKeyDown={(e) => onKeyDown(index, e)}
							style={{
								width: 44,
								height: 52,
								borderRadius: 8,
								border: '1px solid #CFD4D8',
								textAlign: 'center',
								fontSize: 22,
								fontWeight: 700,
								outline: 'none',
							}}
						/>
					))}
				</div>

				<button
					type="button"
					className={`register-enviar${completo ? '' : ' is-disabled'}`}
					onClick={confirmar}
					style={{ marginBottom: 16 }}
					aria-label="Confirmar"
				>
					<svg width="90" height="22" viewBox="0 0 90 22" aria-hidden="true" focusable="false">
						<text x="45" y="16" textAnchor="middle" fill="#122150" fontFamily="Arial, Helvetica, sans-serif" fontSize="16" fontWeight="700">Confirmar</text>
					</svg>
				</button>

				<button
					type="button"
					onClick={() => {
						this.setState({ codigoVerificacao: ['', '', '', '', '', ''] });
						Swal.fire('Pronto', 'Código solicitado por SMS.', 'success');
					}}
					style={{
						display: 'block',
						width: '100%',
						background: 'transparent',
						border: 'none',
						color: '#122150',
						fontSize: 14,
						fontWeight: 600,
						textDecoration: 'underline',
						cursor: 'pointer',
						padding: 8,
					}}
				>
					Enviar por SMS
				</button>
			</div>
		);
	}

	termos = () => {
		const leuDoc = this.state.termosLidos;
		const aceitouDeclaracao = this.state.checked;
		const podeAceitar = leuDoc && aceitouDeclaracao;
		const voltarPara = 'verificacao';
		const pages = this.state.numPages || 0;

		return (
			<div className="register-termos">
				<button
					type="button"
					className="register-termos__voltar"
					onClick={() => this.setState({
						step: voltarPara,
						stepsNumber: 0,
						termosLidos: false,
						checked: false,
					})}
				>
					<AiOutlineArrowLeft size={18} color="#122150" />
					<span>Voltar</span>
				</button>

				<h1 className="register-termos__title">TERMOS DE USO</h1>
				<p className="register-termos__hint">
					Leia integralmente os Termos e Condições Gerais de Uso para continuar.
				</p>

				<div
					className="register-termos__doc"
					onScroll={this.onTermosScroll}
				>
					<Document file="/pdf/termos.pdf" onLoadSuccess={this.onDocumentLoadSuccess}>
						{pages > 0
							? Array.from(new Array(pages), (_, index) => (
								<Page
									key={`p-${index + 1}`}
									pageNumber={index + 1}
									renderTextLayer={false}
									renderAnnotationLayer={false}
									width={this.state.termosDocWidth}
								/>
							))
							: <Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} width={this.state.termosDocWidth} />}
					</Document>
				</div>

				{!leuDoc ? (
					<div className="register-termos__alert">
						<span className="register-termos__alert-icon" aria-hidden="true">!</span>
						<span>Leia o documento até o final para habilitar o aceite.</span>
					</div>
				) : (
					<div className="register-termos__alert is-ok">
						<span>Documento lido. Confirme a declaração abaixo para aceitar.</span>
					</div>
				)}

				<label className={`register-termos__declare${leuDoc ? '' : ' is-disabled'}`}>
					<input
						type="checkbox"
						checked={aceitouDeclaracao}
						disabled={!leuDoc}
						onChange={() => this.setState({ checked: !this.state.checked })}
					/>
					<span>
						Declaro que li integralmente, compreendi e estou de acordo com os Termos e Condições Gerais de Uso da FastFrete.
					</span>
				</label>

				<div className="register-termos__actions">
					<button
						type="button"
						className="register-termos__btn-secondary"
						onClick={() => Swal.fire({
							title: 'Atenção!',
							text: 'Tem certeza que deseja recusar os Termos e Condições Gerais de Uso? Você não poderá continuar seu cadastro sem aceitá-los.',
							icon: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#2A449A',
							cancelButtonColor: '#D92D20',
							cancelButtonText: 'Não',
							confirmButtonText: 'Sim',
						}).then((result) => {
							if (!result.value) return;
							this.setState({
								step: voltarPara,
								termosLidos: false,
								checked: false,
							});
						})}
					>
						Recusar
					</button>
					<button
						type="button"
						className={`register-enviar${podeAceitar ? '' : ' is-disabled'}`}
						disabled={!podeAceitar}
						onClick={() => {
							if (!podeAceitar) return;
							this.setState({ step: 'cadastroForm', stepsNumber: 1 });
						}}
					>
						Aceitar
					</button>
				</div>
			</div>
		);
	}

	cadastroForm = () => {
		const fieldLabel = {
			display: 'block',
			fontSize: 13,
			fontWeight: 600,
			color: '#122150',
			marginBottom: 6,
		};
		const id = this.state.identificacao || {};
		const perfil = this.perfilLabel();
		const isTransp = this.state.tokenType === 'Transportadora';
		const cnpjDigits = String(id.emp_cnpj || '').replace(/\D/g, '');
		const cnpjExibicao = cnpjDigits.length === 14 ? formatCNPJ(cnpjDigits) : (id.emp_cnpj || '—');
		const rntrcExibicao = String(id.emp_rntrc || '').trim() || '—';
		const rntrcTipoExibicao = String(id.rntrc_tipo || 'ETC').trim() || '—';

		return (
			<div className="register-confirmacao">
				<button
					type="button"
					className="register-termos__voltar"
					onClick={() => this.setState({ step: 'termos', stepsNumber: 0, termosLidos: true })}
				>
					<AiOutlineArrowLeft size={18} color="#122150" />
					<span>Voltar</span>
				</button>

				<h1 className="register-termos__title">Confirmação de Dados</h1>
				<p className="register-termos__hint">Confirme seus dados e complete o cadastro</p>

				<div className="register-confirmacao__alert">
					{((this.state.identificacao || {}).vinculo === 'Funcionario')
						? `Confirme os dados de ${perfil}, do responsável legal e do funcionário para continuar.`
						: `Confirme os dados de ${perfil} e complete os dados de contato e do responsável legal para continuar.`}
				</div>

				<Formik
					key={`confirmacao-v4-${id.emp_cnpj || 'novo'}-${(id.vinculo || 'rl')}`}
					initialValues={this.getInitialValues()}
					validate={values => validateConfirmacao(values, { vinculo: id.vinculo || values.vinculo })}
					onSubmit={async (values) => {
						const isFuncionario = (values.vinculo || id.vinculo) === 'Funcionario';
						const livre = await this.checarDisponibilidade({
							emp_cnpj: values.emp_cnpj,
							usu_cpf: values.usu_cpf,
							email: values.email,
							vinculo: values.vinculo || id.vinculo,
							...(isFuncionario ? {
								rl_cpf: values.rl_cpf || id.usu_cpf,
								rl_email: values.rl_email,
							} : {}),
						});
						if (!livre) return;
						const draft = {
							...values,
							vinculo: values.vinculo || id.vinculo || 'ResponsavelLegal',
							usu_cargo: values.usu_cargo || id.usu_cargo || '',
							usu_cep: values.usu_cep || values.emp_cep,
							usu_rua: values.usu_rua || values.emp_logradouro,
							usu_numero: values.usu_numero || values.emp_logradouro_numero,
							usu_bairro: values.usu_bairro || values.emp_bairro,
							usu_cidade: values.usu_cidade || values.emp_municipio,
							usu_uf: values.usu_uf || values.emp_estado,
							usu_complemento: values.usu_complemento || values.emp_endereco_complemento,
						};
						this.setState({ cadastroDraft: draft, step: 'criacaoSenha', stepsNumber: 1 });
					}}
				>
					{({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
						<form noValidate autoComplete="off" onSubmit={handleSubmit}>
							<section className="register-confirmacao__card">
								<div className="register-confirmacao__card-head">
									<p className="register-confirmacao__card-title">Dados de {perfil}</p>
								</div>

								<div className="register-confirmacao__info-row">
									<div className="register-confirmacao__info is-compact">
										<span>CNPJ</span>
										<strong>{cnpjExibicao}</strong>
									</div>
									<div className="register-confirmacao__field-compact">
										<label style={fieldLabel}>Estabelecimento</label>
										<BetterSelect
											variant="outlined"
											name="emp_flag_matriz_filial"
											label=""
											labelWidth={0}
											value={values.emp_flag_matriz_filial || 'Matriz'}
											onChange={handleChange}
											onBlur={handleBlur}
										>
											<option value="Matriz">Matriz</option>
											<option value="Filial">Filial</option>
										</BetterSelect>
									</div>
								</div>
								<hr className="register-confirmacao__divider" />

								<Row>
									<Col xs={12} className="px-2 pb-3">
										<label style={fieldLabel}>Razão Social *</label>
										<FormControl fullWidth error={Boolean(touched.emp_razao_social && errors.emp_razao_social)}>
											<TextField type="text" variant="outlined" name="emp_razao_social" onBlur={handleBlur} error={Boolean(touched.emp_razao_social && errors.emp_razao_social)} onChange={handleChange} value={values.emp_razao_social} inputProps={{ translate: 'no' }} />
											{touched.emp_razao_social && errors.emp_razao_social && <FormHelperText>{errors.emp_razao_social}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>Nome Fantasia *</label>
										<FormControl fullWidth error={Boolean(touched.emp_nome_fantasia && errors.emp_nome_fantasia)}>
											<TextField type="text" variant="outlined" name="emp_nome_fantasia" onBlur={handleBlur} error={Boolean(touched.emp_nome_fantasia && errors.emp_nome_fantasia)} onChange={handleChange} value={values.emp_nome_fantasia} inputProps={{ translate: 'no' }} />
											{touched.emp_nome_fantasia && errors.emp_nome_fantasia && <FormHelperText>{errors.emp_nome_fantasia}</FormHelperText>}
										</FormControl>
									</Col>
								</Row>

								<EmpresaCnaeNaturezaFields
									values={values}
									handleChange={handleChange}
									handleBlur={handleBlur}
									fieldLabel={fieldLabel}
								/>

								{isTransp ? (
									<>
										<hr className="register-confirmacao__divider" />
										<div className="register-confirmacao__info-row">
											<div className="register-confirmacao__info is-compact">
												<span>RNTRC</span>
												<strong>{rntrcExibicao}</strong>
											</div>
											<div className="register-confirmacao__info is-compact">
												<span>Tipo de RNTRC</span>
												<strong>{rntrcTipoExibicao}</strong>
											</div>
											<div className="register-confirmacao__info is-compact">
												<span>Situação do RNTRC</span>
												<strong>—</strong>
											</div>
											<div className="register-confirmacao__info is-compact">
												<span>Data da Consulta</span>
												<strong>—</strong>
											</div>
										</div>
										<p className="meu-perfil__secao-hint" style={{ margin: '0 4px 12px' }}>
											Situação e data da consulta ANTT ainda sem integração.
										</p>
									</>
								) : null}

								<Row>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel} translate="no" title="Inscrição Estadual">Inscrição Estadual</label>
										<FormControl fullWidth>
											<TextField type="text" variant="outlined" name="emp_inscricao_estadual" onBlur={handleBlur} onChange={handleChange} value={values.emp_inscricao_estadual} inputProps={{ translate: 'no' }} />
										</FormControl>
									</Col>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>Inscrição Municipal</label>
										<FormControl fullWidth>
											<TextField type="text" variant="outlined" name="emp_inscricao_municipal" onBlur={handleBlur} onChange={handleChange} value={values.emp_inscricao_municipal || ''} inputProps={{ translate: 'no' }} />
										</FormControl>
									</Col>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>Telefone *</label>
										<FormControl fullWidth error={Boolean(touched.emp_telefone && errors.emp_telefone)}>
											<TextField type="text" variant="outlined" name="emp_telefone" inputProps={{ maxLength: 15, translate: 'no' }} onBlur={handleBlur} error={Boolean(touched.emp_telefone && errors.emp_telefone)} onChange={e => handleChange(formatTelefoneInput(e))} value={values.emp_telefone} />
											{touched.emp_telefone && errors.emp_telefone && <FormHelperText>{errors.emp_telefone}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>E-mail *</label>
										<FormControl fullWidth error={Boolean(touched.emp_email && errors.emp_email)}>
											<TextField type="email" variant="outlined" name="emp_email" onBlur={handleBlur} error={Boolean(touched.emp_email && errors.emp_email)} onChange={handleChange} value={values.emp_email} inputProps={{ translate: 'no' }} />
											{touched.emp_email && errors.emp_email && <FormHelperText>{errors.emp_email}</FormHelperText>}
										</FormControl>
									</Col>
								</Row>
							</section>

							<section className="register-confirmacao__card">
								<div className="register-confirmacao__card-head">
									<p className="register-confirmacao__card-title">Endereço</p>
								</div>
								<Row>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>Tipo de Endereço *</label>
										<BetterSelect
											variant="outlined"
											name="emp_tipo_endereco"
											label=""
											labelWidth={0}
											value={values.emp_tipo_endereco}
											onChange={handleChange}
											onBlur={handleBlur}
											error={Boolean(touched.emp_tipo_endereco && errors.emp_tipo_endereco)}
											helperText={touched.emp_tipo_endereco && errors.emp_tipo_endereco ? errors.emp_tipo_endereco : undefined}
										>
											<option value="">Selecionar...</option>
											<option value="Comercial">Comercial</option>
											<option value="Residencial">Residencial</option>
											<option value="Cobrança">Cobrança</option>
										</BetterSelect>
									</Col>
									<Col xs={12} md={6} className="px-2 pb-3">
										<label style={fieldLabel}>CEP *</label>
										<FormControl fullWidth error={Boolean(touched.emp_cep && errors.emp_cep)}>
											<TextField type="text" variant="outlined" name="emp_cep" inputProps={{ maxLength: 9 }} placeholder="00000-000" onBlur={(e) => handleBlur(buscaCep(e, setFieldValue, 'emp_logradouro', 'emp_bairro', 'emp_municipio', 'emp_estado'))} onChange={(e) => handleChange(formatCepInput(e))} error={Boolean(touched.emp_cep && errors.emp_cep)} value={values.emp_cep} />
											{touched.emp_cep && errors.emp_cep && <FormHelperText>{errors.emp_cep}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={8} className="px-2 pb-3">
										<label style={fieldLabel}>Rua / Logradouro *</label>
										<FormControl fullWidth error={Boolean(touched.emp_logradouro && errors.emp_logradouro)}>
											<TextField type="text" variant="outlined" name="emp_logradouro" placeholder="Nome da rua" onBlur={handleBlur} error={Boolean(touched.emp_logradouro && errors.emp_logradouro)} onChange={handleChange} value={values.emp_logradouro} />
											{touched.emp_logradouro && errors.emp_logradouro && <FormHelperText>{errors.emp_logradouro}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={4} className="px-2 pb-3">
										<label style={fieldLabel}>Nº *</label>
										<FormControl fullWidth error={Boolean(touched.emp_logradouro_numero && errors.emp_logradouro_numero)}>
											<TextField type="text" variant="outlined" name="emp_logradouro_numero" placeholder="0" onBlur={handleBlur} error={Boolean(touched.emp_logradouro_numero && errors.emp_logradouro_numero)} onChange={handleChange} value={values.emp_logradouro_numero} />
											{touched.emp_logradouro_numero && errors.emp_logradouro_numero && <FormHelperText>{errors.emp_logradouro_numero}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} className="px-2 pb-3">
										<label style={fieldLabel}>Bairro *</label>
										<FormControl fullWidth error={Boolean(touched.emp_bairro && errors.emp_bairro)}>
											<TextField type="text" variant="outlined" name="emp_bairro" placeholder="Bairro" onBlur={handleBlur} error={Boolean(touched.emp_bairro && errors.emp_bairro)} onChange={handleChange} value={values.emp_bairro} />
											{touched.emp_bairro && errors.emp_bairro && <FormHelperText>{errors.emp_bairro}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={4} className="px-2 pb-3">
										<label style={fieldLabel}>UF *</label>
										<FormControl fullWidth error={Boolean(touched.emp_estado && errors.emp_estado)}>
											<TextField type="text" variant="outlined" name="emp_estado" onBlur={handleBlur} error={Boolean(touched.emp_estado && errors.emp_estado)} onChange={handleChange} value={values.emp_estado} />
											{touched.emp_estado && errors.emp_estado && <FormHelperText>{errors.emp_estado}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} md={8} className="px-2 pb-3">
										<label style={fieldLabel}>Cidade *</label>
										<FormControl fullWidth error={Boolean(touched.emp_municipio && errors.emp_municipio)}>
											<TextField type="text" variant="outlined" name="emp_municipio" onBlur={handleBlur} error={Boolean(touched.emp_municipio && errors.emp_municipio)} onChange={handleChange} value={values.emp_municipio} />
											{touched.emp_municipio && errors.emp_municipio && <FormHelperText>{errors.emp_municipio}</FormHelperText>}
										</FormControl>
									</Col>
									<Col xs={12} className="px-2 pb-3">
										<label style={fieldLabel}>Complemento (opcional)</label>
										<FormControl fullWidth>
											<TextField type="text" variant="outlined" name="emp_endereco_complemento" placeholder="Apto, bloco, sala..." onBlur={handleBlur} onChange={handleChange} value={values.emp_endereco_complemento} />
										</FormControl>
									</Col>
								</Row>
							</section>

							<section className="register-confirmacao__card">
								<div className="register-confirmacao__card-head">
									<p className="register-confirmacao__card-title">Dados do Responsável Legal</p>
								</div>

								{(values.vinculo || id.vinculo) === 'Funcionario' ? (
									<>
										<Row>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>CPF</label>
												<FormControl fullWidth>
													<TextField
														type="text"
														variant="outlined"
														name="rl_cpf"
														value={values.rl_cpf || ''}
														InputProps={{ readOnly: true }}
														inputProps={{ translate: 'no', tabIndex: -1 }}
													/>
												</FormControl>
											</Col>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>Cargo *</label>
												<FormControl fullWidth error={Boolean(touched.rl_cargo && errors.rl_cargo)}>
													<TextField
														select
														SelectProps={{ native: true }}
														variant="outlined"
														name="rl_cargo"
														value={values.rl_cargo || ''}
														onChange={handleChange}
														onBlur={handleBlur}
														error={Boolean(touched.rl_cargo && errors.rl_cargo)}
														inputProps={{ translate: 'no' }}
													>
														<option value="">Selecione</option>
														{CARGOS_COLABORADORES.map((c) => (
															<option key={c} value={c}>{c}</option>
														))}
													</TextField>
													{touched.rl_cargo && errors.rl_cargo && (
														<FormHelperText>{errors.rl_cargo}</FormHelperText>
													)}
												</FormControl>
											</Col>
											<Col xs={12} className="px-2 pb-3">
												<label style={fieldLabel}>Nome Completo *</label>
												<FormControl fullWidth error={Boolean(touched.rl_nome && errors.rl_nome)}>
													<TextField
														type="text"
														variant="outlined"
														name="rl_nome"
														onBlur={handleBlur}
														error={Boolean(touched.rl_nome && errors.rl_nome)}
														onChange={handleChange}
														value={values.rl_nome || ''}
														autoComplete="off"
														inputProps={{ translate: 'no', autoComplete: 'off' }}
													/>
													{touched.rl_nome && errors.rl_nome && <FormHelperText>{errors.rl_nome}</FormHelperText>}
												</FormControl>
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>Celular *</label>
												<FormControl fullWidth error={Boolean(touched.rl_celular && errors.rl_celular)}>
													<TextField type="text" variant="outlined" name="rl_celular" inputProps={{ maxLength: 15 }} onBlur={handleBlur} error={Boolean(touched.rl_celular && errors.rl_celular)} onChange={e => handleChange(formatTelefoneInput(e))} value={values.rl_celular || ''} />
													{touched.rl_celular && errors.rl_celular && <FormHelperText>{errors.rl_celular}</FormHelperText>}
												</FormControl>
											</Col>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>E-mail *</label>
												<FormControl fullWidth error={Boolean(touched.rl_email && errors.rl_email)}>
													<TextField type="email" variant="outlined" name="rl_email" onBlur={handleBlur} error={Boolean(touched.rl_email && errors.rl_email)} onChange={handleChange} value={values.rl_email || ''} />
													{touched.rl_email && errors.rl_email && <FormHelperText>{errors.rl_email}</FormHelperText>}
												</FormControl>
											</Col>
										</Row>
									</>
								) : (
									<>
										<Row>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>CPF</label>
												<FormControl fullWidth>
													<TextField
														type="text"
														variant="outlined"
														name="usu_cpf"
														value={values.usu_cpf || ''}
														InputProps={{ readOnly: true }}
														inputProps={{ translate: 'no', tabIndex: -1 }}
													/>
												</FormControl>
											</Col>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>Cargo *</label>
												<FormControl fullWidth error={Boolean(touched.usu_cargo && errors.usu_cargo)}>
													<TextField
														select
														SelectProps={{ native: true }}
														variant="outlined"
														name="usu_cargo"
														value={values.usu_cargo || ''}
														onChange={handleChange}
														onBlur={handleBlur}
														error={Boolean(touched.usu_cargo && errors.usu_cargo)}
														inputProps={{ translate: 'no' }}
													>
														<option value="">Selecione</option>
														{CARGOS_COLABORADORES.map((c) => (
															<option key={c} value={c}>{c}</option>
														))}
													</TextField>
													{touched.usu_cargo && errors.usu_cargo && (
														<FormHelperText>{errors.usu_cargo}</FormHelperText>
													)}
												</FormControl>
											</Col>
											<Col xs={12} className="px-2 pb-3">
												<label style={fieldLabel}>Nome Completo *</label>
												<FormControl fullWidth error={Boolean(touched.usu_nome && errors.usu_nome)}>
													<TextField
														type="text"
														variant="outlined"
														name="usu_nome"
														onBlur={handleBlur}
														error={Boolean(touched.usu_nome && errors.usu_nome)}
														onChange={handleChange}
														value={values.usu_nome || ''}
														autoComplete="off"
														inputProps={{ translate: 'no', autoComplete: 'off' }}
													/>
													{touched.usu_nome && errors.usu_nome && <FormHelperText>{errors.usu_nome}</FormHelperText>}
												</FormControl>
											</Col>
										</Row>

										<Row>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>Celular *</label>
												<FormControl fullWidth error={Boolean(touched.usu_celular && errors.usu_celular)}>
													<TextField type="text" variant="outlined" name="usu_celular" inputProps={{ maxLength: 15 }} onBlur={handleBlur} error={Boolean(touched.usu_celular && errors.usu_celular)} onChange={e => handleChange(formatTelefoneInput(e))} value={values.usu_celular} />
													{touched.usu_celular && errors.usu_celular && <FormHelperText>{errors.usu_celular}</FormHelperText>}
												</FormControl>
											</Col>
											<Col xs={12} md={6} className="px-2 pb-3">
												<label style={fieldLabel}>E-mail *</label>
												<FormControl fullWidth error={Boolean(touched.email && errors.email)}>
													<TextField type="email" variant="outlined" name="email" onBlur={handleBlur} error={Boolean(touched.email && errors.email)} onChange={handleChange} value={values.email} />
													{touched.email && errors.email && <FormHelperText>{errors.email}</FormHelperText>}
												</FormControl>
											</Col>
										</Row>

										<div className="register-confirmacao__verify">
											<span className="register-confirmacao__verify-text">Celular verificado</span>
											<button
												type="button"
												className="register-confirmacao__alterar"
												translate="no"
												onClick={() => this.setState({ step: 'identificacao', stepsNumber: 0, cadastroDraft: values })}
											>
												Alterar
											</button>
										</div>
									</>
								)}

								<p className="register-confirmacao__note">
									Os documentos pessoais serão solicitados somente ao acessar uma oferta.
								</p>
							</section>

							{(values.vinculo || id.vinculo) === 'Funcionario' ? (
								<section className="register-confirmacao__card">
									<div className="register-confirmacao__card-head">
										<p className="register-confirmacao__card-title">Dados do Funcionário</p>
									</div>
									<Row>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel}>CPF</label>
											<FormControl fullWidth>
												<TextField
													type="text"
													variant="outlined"
													name="usu_cpf"
													value={values.usu_cpf || ''}
													InputProps={{ readOnly: true }}
													inputProps={{ translate: 'no', tabIndex: -1 }}
												/>
											</FormControl>
										</Col>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel}>Cargo *</label>
											<FormControl fullWidth error={Boolean(touched.usu_cargo && errors.usu_cargo)}>
												<TextField
													select
													SelectProps={{ native: true }}
													variant="outlined"
													name="usu_cargo"
													value={values.usu_cargo || ''}
													onChange={handleChange}
													onBlur={handleBlur}
													error={Boolean(touched.usu_cargo && errors.usu_cargo)}
													inputProps={{ translate: 'no' }}
												>
													<option value="">Selecione</option>
													{CARGOS_COLABORADORES.map((c) => (
														<option key={c} value={c}>{c}</option>
													))}
												</TextField>
												{touched.usu_cargo && errors.usu_cargo && (
													<FormHelperText>{errors.usu_cargo}</FormHelperText>
												)}
											</FormControl>
										</Col>
										<Col xs={12} className="px-2 pb-3">
											<label style={fieldLabel}>Nome Completo *</label>
											<FormControl fullWidth error={Boolean(touched.usu_nome && errors.usu_nome)}>
												<TextField
													type="text"
													variant="outlined"
													name="usu_nome"
													onBlur={handleBlur}
													error={Boolean(touched.usu_nome && errors.usu_nome)}
													onChange={handleChange}
													value={values.usu_nome || ''}
													autoComplete="off"
													inputProps={{ translate: 'no', autoComplete: 'off' }}
												/>
												{touched.usu_nome && errors.usu_nome && <FormHelperText>{errors.usu_nome}</FormHelperText>}
											</FormControl>
										</Col>
									</Row>
									<Row>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel}>Celular *</label>
											<FormControl fullWidth error={Boolean(touched.usu_celular && errors.usu_celular)}>
												<TextField type="text" variant="outlined" name="usu_celular" inputProps={{ maxLength: 15 }} onBlur={handleBlur} error={Boolean(touched.usu_celular && errors.usu_celular)} onChange={e => handleChange(formatTelefoneInput(e))} value={values.usu_celular} />
												{touched.usu_celular && errors.usu_celular && <FormHelperText>{errors.usu_celular}</FormHelperText>}
											</FormControl>
										</Col>
										<Col xs={12} md={6} className="px-2 pb-3">
											<label style={fieldLabel}>E-mail *</label>
											<FormControl fullWidth error={Boolean(touched.email && errors.email)}>
												<TextField type="email" variant="outlined" name="email" onBlur={handleBlur} error={Boolean(touched.email && errors.email)} onChange={handleChange} value={values.email} />
												{touched.email && errors.email && <FormHelperText>{errors.email}</FormHelperText>}
											</FormControl>
										</Col>
									</Row>
									<div className="register-confirmacao__verify">
										<span className="register-confirmacao__verify-text">Celular verificado</span>
										<button
											type="button"
											className="register-confirmacao__alterar"
											translate="no"
											onClick={() => this.setState({ step: 'identificacao', stepsNumber: 0, cadastroDraft: values })}
										>
											Alterar
										</button>
									</div>
									<p className="register-confirmacao__note">
										Este e-mail e senha serão usados para acessar o painel.
									</p>
								</section>
							) : null}

							<button
								type="submit"
								className="register-enviar register-confirmacao__submit"
								disabled={this.state.checkingDisponibilidade}
							>
								{this.state.checkingDisponibilidade ? 'Verificando...' : 'Confirmar'}
							</button>
						</form>
					)}
				</Formik>
			</div>
		);
	}

	criacaoSenha = () => {
		const fieldLabel = {
			display: 'block',
			fontSize: 13,
			fontWeight: 600,
			color: '#122150',
			marginBottom: 6,
		};
		const draft = this.state.cadastroDraft || this.getInitialValues();
		const id = this.state.identificacao || {};
		const isFuncionario = (draft.vinculo || id.vinculo) === 'Funcionario';
		const senhaTitle = isFuncionario
			? 'Criar senha de acesso do funcionário'
			: 'Criar senha de acesso do responsável legal';

		return (
			<div className="register-senha">
				<button
					type="button"
					className="register-termos__voltar"
					onClick={() => this.setState({ step: 'cadastroForm', stepsNumber: 1 })}
				>
					<AiOutlineArrowLeft size={18} color="#122150" />
					<span>Voltar</span>
				</button>

				<div className="register-senha__hero">
					<div className="register-senha__icon">
						<FaLock size={22} color="#F6A900" />
					</div>
					<h1 className="register-termos__title" translate="no">{senhaTitle}</h1>
					<p className="register-termos__hint">Defina sua senha para acessar a plataforma FastFrete</p>
				</div>

				<Formik
					key={`senha-v3-${draft.emp_cnpj || 'novo'}-${draft.vinculo || 'rl'}`}
					initialValues={{
						password: '',
						confirm: '',
					}}
					validate={values => validateCriacaoSenha(values)}
					onSubmit={(values) => {
						const payload = {
							...draft,
							password: values.password,
							confirm: values.confirm,
							vinculo: draft.vinculo || id.vinculo || 'ResponsavelLegal',
							usu_cargo: draft.usu_cargo || id.usu_cargo || '',
							usu_cep: draft.usu_cep || draft.emp_cep,
							usu_rua: draft.usu_rua || draft.emp_logradouro,
							usu_numero: draft.usu_numero || draft.emp_logradouro_numero,
							usu_bairro: draft.usu_bairro || draft.emp_bairro,
							usu_cidade: draft.usu_cidade || draft.emp_municipio,
							usu_uf: draft.usu_uf || draft.emp_estado,
							usu_complemento: draft.usu_complemento || draft.emp_endereco_complemento || '',
							usu_celular: draft.usu_celular || id.usu_celular || draft.emp_telefone || '',
							emp_cnpj: draft.emp_cnpj || id.emp_cnpj || '',
							emp_rntrc: draft.emp_rntrc || id.emp_rntrc || '',
							rntrc_tipo: draft.rntrc_tipo || id.rntrc_tipo || 'ETC',
						};
						if (payload.vinculo === 'Funcionario') {
							payload.usu_cpf = draft.usu_cpf || id.usu_cpf_funcionario || '';
							payload.rl_cpf = draft.rl_cpf || id.usu_cpf || '';
							payload.rl_cargo = draft.rl_cargo || '';
							payload.rl_nome = draft.rl_nome || '';
							payload.rl_email = draft.rl_email || '';
							payload.rl_celular = draft.rl_celular || '';
						} else {
							payload.usu_cpf = draft.usu_cpf || id.usu_cpf || '';
						}
						this.onSubmit(payload);
					}}
				>
					{({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => {
						const digitouConfirm = Boolean(values.confirm);
						const senhasIguais = values.password && values.confirm && values.password === values.confirm;
						const senhasDivergem = digitouConfirm && values.password !== values.confirm;

						return (
						<form noValidate autoComplete="off" onSubmit={handleSubmit}>
							<div className="px-1 pb-3">
								<label style={fieldLabel} translate="no">Senha *</label>
								<FormControl fullWidth error={Boolean(touched.password && errors.password)}>
									<TextField
										type="password"
										variant="outlined"
										name="password"
										placeholder="Mínimo 8 caracteres"
										onBlur={handleBlur}
										error={Boolean(touched.password && errors.password)}
										onChange={handleChange}
										value={values.password}
										inputProps={{ translate: 'no', autoComplete: 'new-password' }}
									/>
									{touched.password && errors.password && <FormHelperText>{errors.password}</FormHelperText>}
								</FormControl>
							</div>
							<div className="px-1 pb-3">
								<label style={fieldLabel} translate="no">Confirmar senha *</label>
								<FormControl fullWidth error={Boolean((touched.confirm && errors.confirm) || senhasDivergem)}>
									<TextField
										type="password"
										variant="outlined"
										name="confirm"
										placeholder="Repita a senha"
										onBlur={handleBlur}
										error={Boolean((touched.confirm && errors.confirm) || senhasDivergem)}
										onChange={handleChange}
										value={values.confirm}
										inputProps={{ translate: 'no', autoComplete: 'new-password' }}
									/>
									{touched.confirm && errors.confirm && <FormHelperText>{errors.confirm}</FormHelperText>}
								</FormControl>
								{senhasIguais && (
									<div className="register-senha__match is-ok" translate="no">As senhas coincidem</div>
								)}
								{senhasDivergem && (
									<div className="register-senha__match is-bad" translate="no">As senhas não coincidem</div>
								)}
							</div>

							<button type="submit" disabled={this.state.loading || senhasDivergem} className="register-enviar mt-2" translate="no">
								{this.state.loading ? 'Enviando...' : 'Confirmar'}
							</button>
						</form>
						);
					}}
				</Formik>
			</div>
		);
	}

	bemVindo = () => (
		<CadastroConclusao variante="matriz" onFechar={() => { window.location.href = '/'; }} />
	)

	onboardingStepIndex = () => {
		switch (this.state.step) {
			case 'tipoConta':
				return 0;
			case 'identificacao':
				return 1;
			case 'verificacao':
				return 2;
			case 'termos':
				return 3;
			case 'cadastroForm':
				return 4;
			case 'criacaoSenha':
				return 5;
			case 'bemVindo':
				return 5;
			default:
				return 0;
		}
	}

	render = () => {
		const showStepper = this.state.step !== 'bemVindo';
		const progresso = Math.floor(((this.onboardingStepIndex() + 1) / ONBOARDING_STEPS.length) * 100);

		return (
			<Container fluid className="p-0 registerContainer register-shell">
				<header className="register-topbar">
					<img src="/images/logo-white.png" alt="FastFrete" className="register-topbar__logo" />
				</header>

				{showStepper && (
					<div className="register-progress">
						<div className="register-progress__bar" style={{ width: `${progresso}%` }} />
						<span className="register-progress__badge" style={{ left: `${progresso}%` }}>{progresso}%</span>
					</div>
				)}

				<div className={`register-form-layout${showStepper ? '' : ' is-welcome'}`}>
					{showStepper && (
						<aside className="register-stepper-rail">
							<OnboardingStepper current={this.onboardingStepIndex()} />
						</aside>
					)}
					<div className="formSide register-form-main">
						{this.switchEtapas()}
					</div>
				</div>
			</Container>
		);
	}
}

export default connect(null, auth.actions)(Register);